import { Component } from "react";
import { reportError } from "@/lib/errorReporter";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
    reportError(error, { componentStack: info?.componentStack, source: "boundary" });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="error-boundary">
          <div className="w-14 h-14 rounded-full bg-[#C86B5E]/10 flex items-center justify-center mx-auto mb-6">
            <span className="font-heading text-2xl text-[#C86B5E]">!</span>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl tracking-tight mb-4">
            Un instant, une petite <span className="italic">difficulté</span>.
          </h1>
          <p className="text-[#5C5754] leading-relaxed mb-8">
            Cette page n'a pas pu s'afficher correctement. Rafraîchissez la page&nbsp;;
            si le souci persiste, revenez à l'accueil et reconnectez-vous.
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="bg-[#C86B5E] hover:bg-[#B35A4E] text-white rounded-full px-6 py-3 transition-colors"
            >
              Rafraîchir la page
            </button>
            <a
              href="/"
              data-testid="error-boundary-home"
              className="border border-[#E6E2DD] hover:border-[#C86B5E] text-[#5C5754] hover:text-[#C86B5E] rounded-full px-6 py-3 transition-colors"
            >
              Retour à l'accueil
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
